<template lang="pug">
  .profile-page-form
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Памятка родителям
      .profile-section__body
        .form
          .form__elem(
          v-for="(item, index) in fields.things"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title {{index === 0 ? "Пункты" : ""}}
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.things[index]"
                )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddItem"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__body
        .form
          .form__elem.form__elem_button
            .form-elem(
            v-if="campData"
            )
              .form-elem__body
                router-link.button.button_long(
                :to="{name: 'CurrentCamp', params: {campId: campData.id}}"
                target="_blank"
                )
                  .button__text Просмотр
            .form-elem
              .form-elem__body
                button.button.button_paint-main.button_long(
                @click.prevent="onSaveCamp"
                )
                  .button__text Сохранить
</template>

<script>
export default {
  name: "ManagerCampEditorThings",
  props: {
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fields: {
        things: [""]
      }
    };
  },
  methods: {
    setFields(campData) {
      if (campData.necessary_equipment) {
        this.fields.things = campData.necessary_equipment.split(";");
      }
    },
    onAddItem() {
      this.fields.things.push("");
    },
    onSaveCamp() {
      const things = this.fields.things.filter(item => {
        if (item.length > 0) {
          return item;
        }
      });
      if (things.length === 0) {
        things.push("");
      }
      this.fields.things = things;
      const requiredThings = things.join(";");
      const data = {
        necessary_equipment: requiredThings
      };
      this.$emit("on-save-camp", data);
    }
  },
  watch: {
    campData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    if (this.campData) {
      this.setFields(this.campData);
    }
  }
};
</script>
